import BottomSheetBridge from './bottomSheetBridge';
import AnimationScreenBridge from './animationScreenBridge';
import ToastBridge from './toastBridge';

const BRIDGES = {
  BottomSheetBridge: BottomSheetBridge,
  ToastBridge: ToastBridge,
  AnimationScreenBridge: AnimationScreenBridge,
};

export default BRIDGES;
